import getDashboardRoute from "./getDashboardRoute";

export const APP_BASE_PATH = "/app";
export const SYSTEM_TERMS_ROUTE = `${APP_BASE_PATH}/system-access/terms`;
export const SYSTEM_FEES_ROUTE = `${APP_BASE_PATH}/system-access/fees`;
export const GROUP_SELECTION_ROUTE = `${APP_BASE_PATH}/my-groups`;

export const getSystemAccessRoute = (user) => {
  if (!user) {
    return null;
  }

  switch (user.next_required_action) {
    case "ACCEPT_TERMS":
      return SYSTEM_TERMS_ROUTE;
    case "PAY_SRF":
    case "PAY_SAF":
      return SYSTEM_FEES_ROUTE;
    default:
      return null;
  }
};

export const isSystemAccessRemediationPath = (pathname = "") =>
  pathname.startsWith(`${APP_BASE_PATH}/system-access/`);

export const getPostAuthRoute = (user, options = {}) => {
  const { requireGroupSelection = true } = options;

  if (!user) {
    return "/login";
  }

  if (user.password_reset_required) {
    return "/account-activation";
  }

  const remediationRoute = getSystemAccessRoute(user);
  if (remediationRoute) {
    return remediationRoute;
  }

  if (requireGroupSelection && Number(user.memberships_count || 0) > 1) {
    return GROUP_SELECTION_ROUTE;
  }

  return getDashboardRoute(user);
};
